import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../../../services/storage/storage.service';
import * as toastr from 'toastr';

@Injectable()
export class CdcLojaGuard implements CanActivate {
  constructor(private router: Router, private storage: StorageService) {}

  canActivate(): Observable<boolean> | boolean {
    // Bloqueia as funcionalidades da CDC Loja
    this.router.navigate(['/login']);
    this.storage.clearSession();
    toastr.error('Opção ou funcionalidade indisponível');
    return false;
  }
}
